<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import QrCodeGenerator from './components/QRCodeGenerator.vue'
import GoodTable from './components/List.vue'
export default {
  name: 'App',
  components: {
    QrCodeGenerator,
    GoodTable
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>  ``



// WEBPACK FOOTER //
// src/App.vue